<template>
  <div class="editPage">
    <TopBack :title="$t('lang.setting.myInfo')"/>
    <div class="editContainer" v-show="loadOk===true">
      <div class="row">
        <div class="caption">
          {{ $t('lang.login.username') }}
        </div>
        <div class="inputRow">
          <div>
            <label>
              <input type="text" placeholder="User Name" v-model="userInfo.UserName">
            </label>
          </div>

        </div>
        <p class="checkMaxNum" v-if="checkMaxNum(userInfo.UserName)">{{ $t('lang.setting.checkMaxNum') }}</p>
      </div>
      <div class="row">
        <div class="caption">
          {{ $t('lang.login.birthday') }}
        </div>
        <div class="inputRow">
          <!--          <div>-->
          <!--            <label>-->
          <DatePicker :value="userInfo.Birthday" class="PickerInputRow" ref="datePicker" @getDate="getDate"></DatePicker>
          <!--              <input type="text" placeholder="22-02-2000" v-model="userInfo.Birthday"-->
          <!--                     :readonly="!editBirthday?true:false"-->
          <!--                     :style="{ 'color': !editBirthday ? '#F6D9AA' : '' }">-->
          <!--            </label>-->
          <!--          </div>-->
        </div>
        <span class="birthdayTip">{{ $t('lang.setting.birthdayTip') }}</span>
      </div>
      <div class="row" v-if="userInfo.Mobile!==''">
        <div class="caption">
          {{ $t('lang.setting.mobile') }}
        </div>
        <div class="inputRow">
          <div style="color: #F6D9AA">+{{ userInfo.CountryCode }}</div>
          <div style="color: #F6D9AA">******{{ userInfo.Mobile }}</div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="caption">
          {{ $t('lang.setting.mobile') }}
        </div>
        <div class="inputRow">
          <div style="color: #F6D9AA">+{{ userInfo.CountryCode }}</div>
          <div style="color: #F6D9AA"><input v-model="pageMobile" @input="inputMobile"/></div>
        </div>
      </div>
      <div class="row" style="margin-top: -2vw" v-if="!userInfo.Mobile">
        <div class="caption">
          {{ $t('lang.login.otp') }}
        </div>
        <div class="inputRow">
          <div :class="isOtpSent?'':'email'">
            <label>
              <input type="number" v-model="otpCode" @input="checkAndBindMobile"/>
            </label>
          </div>
          <div class="sendCode" :style="pageMobile&&!isOtpSent?'':'background:#797979'" @click="send2OTP">
            <span v-show="otpCountDown>0">{{ otpCountDown + '(s)' }}</span>
            <span v-show="otpCountDown<=0">{{ $t('lang.login.sendOtp') }}</span>
          </div>
        </div>
        <span class="emailTip">{{ otpTip }}</span>
      </div>
      <!--                                   Email Binding                                    -->
      <div class="row" v-if="userInfo.Email">
        <div class="caption">
          {{ $t('lang.login.email') }}
        </div>
        <div class="inputRow">
          <div style="color: #F6D9AA">
            {{ userInfo.Email }}
          </div>
        </div>
        <span class="emailTip">{{ emailTip }}</span>
      </div>
      <div class="row" v-else>
        <div class="caption">
          {{ $t('lang.login.email') }}
        </div>
        <div class="inputRow">
          <div :class="isMailSent?'':'email'">
            <label>
              <input type="text" placeholder="Email" v-model="pageEmail" @input="inputEmail"/>
            </label>
          </div>
          <div class="sendCode" :style="pageEmail?'':'background:#797979'" v-show="!isMailSent" @click="send2Email">
            <span :style="$store.state.locale==='IN'?'font-size:3.888vw':''">
            {{
                mailSendTimes === 0 ? $t('lang.setting.getValidateCode') : $t('lang.setting.resendValidateCode')
              }}
            </span>
          </div>
        </div>
        <span class="emailTip">{{ emailTip }}</span>
      </div>
      <div class="row" style="margin-top:-6vw" v-if="mailCountDown>0&&!userInfo.Email">
        <div class="inputRow">
          <div class="email">
            <label>
              <input type="number" v-model="emailValidateCode" maxlength="4" @input="checkAndBindEmail"/>
            </label>
          </div>
          <div class="countdown" v-show="mailCountDown>0">{{ mailCountDown + 's' }}</div>
        </div>
        <span class="validateTip">{{ validateTip }}</span>
      </div>
      <div class="submit" @click="update">{{ $t('lang.setting.save') }}</div>
    </div>
  </div>
</template>

<script>
import {Toast} from 'mint-ui'
import TopBack from '@/components/TopBack/index'
import request from '@/service'
import {mapMutations} from 'vuex'
import {LogUtils} from '@/utils'
import DatePicker from '../../components/DatePicker/index.vue'

export default {
  name: 'Edit',
  data () {
    return {
      loadOk: false,
      emailReg: RegExp(/^(.{1,254})@(.{1,254})$/),
      editBirthday: true,
      userInfo: {},
      maxNum: false,
      isMailSent: false,
      isOtpSent: false,
      emailTip: '',
      otpTip: '',
      validateTip: '',
      emailValidateCode: '',
      otpCode: '',
      mailCountDown: -1,
      otpCountDown: -1,
      emailInterval: null,
      onBindEmail: false,
      onBindMobile: false,
      otpInterval: null,
      pageEmail: '',
      pageMobile: null,
      mailSendTimes: 0
    }
  },
  components: {
    TopBack,
    DatePicker
  },
  mounted () {
    if (!localStorage.getItem('userInfo')) {
      this.$router.push('/Login')
      return
    }
    request('post', '/innovation/account/getuserinfo', {
      userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
      isEditPage: true
    }).then(res => {
      // 隐藏红点
      this.$store.commit('setShowUserInformationRedDot', false)
      this.userInfo = res
      this.editBirthday = !this.userInfo.Birthday
      this.loadOk = true
      if (res.Mobile) {
        let user = JSON.parse(localStorage.getItem('userInfo'))
        user.Mobile = res.Mobile
        localStorage.setItem('userInfo', JSON.stringify(user))
      }
    })
  },
  beforeDestroy () {
    if (this.emailInterval) {
      clearInterval(this.emailInterval)
    }
    if (this.otpInterval) {
      clearInterval(this.otpInterval)
    }
  },
  methods: {
    ...mapMutations({
      updateUserName: 'updateUserName'
    }),
    getDate (v) {
      console.log(v)
      this.userInfo.Birthday = v
    },
    checkMaxNum (str) {
      if (str) {
        this.maxNum = str.length > 14
        return str.length > 14
      } else {
        return str
      }
    },
    inputMobile () {
      this.otpCode = ''
      if (this.pageMobile !== '') {
        this.otpTip = ''
      }
      if (this.pageMobile.length > 20) {
        this.pageMobile = this.pageMobile.substring(0, 20)
      }
    },
    inputEmail () {
      if (this.pageEmail !== '') {
        this.emailTip = ''
      }
      if (this.emailInterval) {
        this.isMailSent = false
        this.mailCountDown = 0
        clearInterval(this.emailInterval)
      }
    },
    send2Email () {
      if (!this.pageEmail) {
        this.emailTip = this.$t('lang.setting.enterMail')
        return
      } else if (!this.emailReg.test(this.pageEmail)) {
        this.emailTip = this.$t('lang.setting.correctMail')
        return
      }
      request('post', '/innovation/account/bind/email/sendsns', {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        email: this.pageEmail
      }).then(res => {
        if (res.Code === 0) {
          this.mailCountDown = 60
          this.emailTip = ''
          Toast(this.$t('lang.setting.sendOK'))
          if (this.emailInterval) {
            clearInterval(this.emailInterval)
          }
          this.emailInterval = setInterval(() => {
            if (this.mailCountDown > 0) {
              this.mailCountDown = this.mailCountDown - 1
            } else {
              if (this.emailInterval) {
                clearInterval(this.emailInterval)
              }
              this.isMailSent = false
            }
          }, 1000)
          this.isMailSent = true
          this.mailSendTimes++
        } else if (res.Code === 10004) {
          Toast(this.$t('lang.setting.inUse'))
        } else {
          Toast(res.retMsg)
        }
      })
    },
    send2OTP () {
      if (!this.pageMobile) {
        this.otpTip = this.$t('lang.login.invalid')
        return
      }
      request('post', '/innovation/account/bind/mobile/sendsns', {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        countryCode: this.userInfo.CountryCode,
        mobile: this.pageMobile
      }).then(res => {
        if (res.Code === 0) {
          if (res.CodeForTestOnly) {
            this.otpCode = res.CodeForTestOnly
          }
          this.otpCountDown = 60
          this.otpTip = ''
          this.otpInterval = setInterval(() => {
            if (this.otpCountDown > 0) {
              this.otpCountDown = this.otpCountDown - 1
            } else {
              this.otpCode = ''
              if (this.otpInterval) {
                clearInterval(this.otpInterval)
              }
              this.isOtpSent = false
            }
          }, 1000)
          this.isOtpSent = true
        } else if (res.Code === 10001) {
          Toast(this.$t('lang.setting.mobileInUse'))
        } else {
          Toast(res.retMsg)
        }
      })
    },
    checkAndBindEmail () {
      this.emailValidateCode = this.emailValidateCode.replace(/\D/g, '').slice(0, 4)
      if (!this.pageEmail) {
        return
      }
      if (!this.onBindEmail && this.emailValidateCode.length === 4) {
        this.onBindEmail = true
        request('post', '/innovation/account/bind/email', {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
          email: this.pageEmail.toLowerCase(),
          snsCode: this.emailValidateCode
        }).then(res => {
          this.emailValidateCode = ''
          this.onBindEmail = false
          if (res.Code === true && res.Email) {
            this.userInfo.Email = res.Email
            // 刷新小红点
            LogUtils.getRedDot(this.userInfo)
            Toast(this.$t('lang.loginError.bindSuccess'))
          } else {
            if (res.Code === 3) {
              Toast(this.$t('lang.loginError.error03'))
            } else if (res.Code === 2) {
              Toast(this.$t('lang.loginError.error02'))
            } else if (res.Code === 10100) {
              Toast(this.$t('lang.loginError.error10100'))
            } else if (res.Code === 60002) {
              Toast(this.$t('lang.loginError.error60002'))
            } else if (res.Code === 60001) {
              Toast(this.$t('lang.loginError.error60001'))
            } else if (res.Code === 10001) {
              Toast(this.$t('lang.loginError.error10001'))
            } else if (res.Code === 10042) {
              Toast(this.$t('lang.loginError.error10042'))
            } else if (res.Code === 10043) {
              Toast(this.$t('lang.loginError.error10043'))
            } else if (res.Code === 10051) {
              Toast(this.$t('lang.loginError.error10051'))
            } else if (res.Code === 10044) {
              Toast(this.$t('lang.loginError.error10044'))
            } else if (res.Code === 10053) {
              Toast(this.$t('lang.loginError.error10053'))
            } else if (res.Code === 10059) {
              Toast(this.$t('lang.loginError.error10059'))
            } else if (res.Code === 10052) {
              Toast('GoogleId already exists!')
            } else if (res.Code === 10054) {
              Toast('FacebookId already exists!')
            } else if (res.Code === 10060) {
              Toast(this.$t('lang.loginError.error10060'))
            } else if (res.Code === 10202) {
              Toast(this.$t('lang.loginError.bindError'))
            }
          }
        })
      }
    },
    checkAndBindMobile () {
      this.otpCode = this.otpCode.substring(0, 4)
      if (!this.pageMobile) {
        return
      }
      if (!this.onBindMobile && this.otpCode.length === 4) {
        if (this.otpCountDown <= 0) {
          if (this.isOtpSent === true) {
            Toast(this.$t('lang.setting.overtime'))
          }
          return
        }
        this.onBindMobile = true
        request('post', '/innovation/account/bind/mobile', {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
          mobile: this.pageMobile,
          snsCode: this.otpCode,
          countryCode: this.userInfo.CountryCode
        }).then(res => {
          this.otpCode = ''
          this.onBindMobile = false
          if (res.Code === 0 && res.Mobile) {
            this.userInfo.Mobile = res.Mobile
            let user = JSON.parse(localStorage.getItem('userInfo'))
            user.Mobile = res.Mobile
            localStorage.setItem('userInfo', JSON.stringify(user))
            // 刷新小红点
            LogUtils.getRedDot(this.userInfo)
            Toast(this.$t('lang.loginError.bindSuccess'))
          } else {
            if (res.Code === 3) {
              Toast(this.$t('lang.loginError.error03'))
            } else if (res.Code === 2) {
              Toast(this.$t('lang.loginError.error02'))
            } else if (res.Code === 10100) {
              Toast(this.$t('lang.loginError.error10100'))
            } else if (res.Code === 60002) {
              Toast(this.$t('lang.loginError.error60002'))
            } else if (res.Code === 60001) {
              Toast(this.$t('lang.loginError.error60001'))
            } else if (res.Code === 10001) {
              Toast(this.$t('lang.loginError.error10001'))
            } else if (res.Code === 10042) {
              Toast(this.$t('lang.loginError.error10042'))
            } else if (res.Code === 10043) {
              Toast(this.$t('lang.loginError.error10043'))
            } else if (res.Code === 10051) {
              Toast(this.$t('lang.loginError.error10051'))
            } else if (res.Code === 10044) {
              Toast(this.$t('lang.loginError.error10044'))
            } else if (res.Code === 10053) {
              Toast(this.$t('lang.loginError.error10053'))
            } else if (res.Code === 10059) {
              Toast(this.$t('lang.loginError.error10059'))
            } else if (res.Code === 10052) {
              Toast('GoogleId already exists!')
            } else if (res.Code === 10054) {
              Toast('FacebookId already exists!')
            } else if (res.Code === 10060) {
              Toast(this.$t('lang.loginError.error10060'))
            } else if (res.Code === 10202) {
              Toast(this.$t('lang.loginError.bindError'))
            }
          }
        })
      }
    },
    update () {
      if (!this.userInfo.UserName || this.maxNum) {
        return
      }

      // 根据正则表达式校验格式是否正确
      let pattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01])-(0[1-9]|1[012])-\d{4}$/
      if (this.userInfo.Birthday && !pattern.test(this.userInfo.Birthday)) {
        Toast(this.$t('lang.setting.incorrectBirthday'))
        return
      }
      // 校验是否是一个合法的日期
      try {
        // 将日期字符串转换为 Date 对象
        var parts = this.userInfo.Birthday.split('-')
        var day = parseInt(parts[0], 10)
        var month = parseInt(parts[1], 10) - 1 // 月份在 JavaScript 的 Date 对象中从 0 开始，所以需要减去 1
        var year = parseInt(parts[2], 10)
        var inputDate = new Date(year, month, day)
        // 如果输入不合法的日期，new Date并不会报错，例如：输入29-02-1999，inputDate转换后等于01-03-1999，并不会抛异常
        if (day !== inputDate.getDate() || month !== inputDate.getMonth() || year !== inputDate.getFullYear()) {
          Toast(this.$t('lang.setting.incorrectBirthday'))
          return
        }
        if (inputDate > new Date()) {
          Toast(this.$t('lang.setting.incorrectBirthday'))
          return
        }
      } catch (error) {
        Toast(this.$t('lang.setting.incorrectBirthday'))
        return
      }
      console.log(this.isMailSent)
      if (this.mode === 'mail') {
        if (!this.pageEmail) {
          this.emailTip = this.$t('lang.setting.enterMail')
          return
        } else if (!this.emailReg.test(this.pageEmail)) {
          this.emailTip = this.$t('lang.setting.correctMail')
          return
        } else if (this.isMailSent === false) {
          this.emailTip = this.$t('lang.setting.sendFirst')
          return
        } else if (!this.emailValidateCode) {
          Toast(this.$t('lang.setting.noVerificationCode'))
          return
        }
      }
      request('put', '/innovation/account/updateuserinfo', {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        ...this.userInfo
      }).then(res => {
        if (res.Code === 10000) {
          Toast(this.$t('lang.setting.usernameExist'))
        } else {
          localStorage.setItem('userInfo', JSON.stringify({
            ...JSON.parse(localStorage.getItem('userInfo')),
            ...res
          }))
          this.updateUserName(res.UserName)
          if (this.userInfo.Birthday) {
            this.editBirthday = false
          } else {
            this.editBirthday = true
          }
          Toast(this.$t('lang.setting.saveSuccess'))
        }
        sessionStorage.Birthday = this.userInfo.Birthday
      })
    }
  }
}
</script>

<style lang="less" scoped>
.editPage {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 66px;

  .editContainer {
    margin: 0 16px;

    .row {
      position: relative;
      margin: 7.5vw auto;

      .birthdayTip {
        position: absolute;
        bottom: -6.11vw;
        font-size: 3.611vw;
        color: #747474;
      }

      .emailTip {
        position: absolute;
        bottom: -6.11vw;
        font-size: 3.611vw;
        color: #ff0000;
      }

      .caption {
        font-size: 5vw;
        line-height: 5.833vw;
        color: #F6D9AA;
        margin-bottom: 2.777vw;
        display: flex;
        justify-content: space-between;
      }

      .checkMaxNum {
        color: red;
        font-size: 4vw;
      }

      .inputRow {
        display: flex;

        .PickerInputRow {
          flex: 1;
          font-size: 16px;
          color: #fff;
          text-align: center;
          line-height: 40px;
          border: 1px solid rgba(246, 217, 170, 0.5);
          border-radius: 6px;
          padding: 0px 15px;
          height: 100%;
        }

        div {
          flex: 1;
          font-size: 16px;
          color: #fff;
          text-align: center;
          line-height: 40px;
          border: 1px solid #E9CDA1;
          border-radius: 6px;
          padding: 0 15px;

          &:not(:first-child) {
            margin-left: 10px;
            flex: 4;
          }

          input {
            width: 100%;
            font-size: 16px;
            color: #fff;
            text-align: center;
          }
        }

        .email {
          flex: none !important;
          width: 52.436vw !important;
          height: 11.944vw !important;
          border-radius: 1.111vw !important;
        }

        .sendCode {
          text-transform: capitalize;
          flex: none !important;
          width: 36.058vw !important;
          height: 11.788vw !important;
          line-height: 11.788vw;
          border-radius: 1.111vw !important;
          border: none;
          background: #F6D9AA;
          color: #000000;
          font-size: 4.444vw;
          font-weight: 600;
          padding: 0;
          text-align: center;
          white-space: nowrap;
        }

        .countdown {
          flex: none !important;
          width: 36.058vw !important;
          height: 11.788vw !important;
          line-height: 11.788vw;
          border-radius: 1.111vw !important;
          border: none;
          background: #797979;
          color: #000000;
          font-size: 4.444vw;
          font-weight: 600;
        }
      }
    }

    .submit {
      position: relative;
      top: 10vw;
      width: 91.111vw;
      height: 11.666vw;
      font-size: 6.111vw;
      line-height: 11.666vw;
      color: #000D2E;
      text-align: center;
      background-color: #F6D9AA;
      border-radius: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Edit/index.vue